import { DELETE_WORKER_FROM_IMPORTANT_TASK } from "../../../../enums/Request/request.types";

export const deleteWorkerFromImportantTaskAction = (index) => {
    return {
        type: DELETE_WORKER_FROM_IMPORTANT_TASK,
        payload: index,
    };
};